/* eslint react-hooks/exhaustive-deps: "warn" */

import { useContext } from 'react';

import { ContentContext } from 'context/ContentContext';

import { useInt } from 'hooks/useInt';

import { DeliveryTable } from 'ui/organisms/DeliveryTable/DeliveryTable';

import { InvestmentScreeningHero } from 'landing-pages/investment-screening/sections/InvestmentScreeningHero/InvestmentScreeningHero';
import { InvestmentScreeningProblem } from 'landing-pages/investment-screening/sections/InvestmentScreeningProblem/InvestmentScreeningProblem';
import { InvestmentScreeningWorkflow } from 'landing-pages/investment-screening/sections/InvestmentScreeningWorkflow/InvestmentScreeningWorkflow';
import { InvestmentScreeningCoverage } from 'landing-pages/investment-screening/sections/InvestmentScreeningCoverage/InvestmentScreeningCoverage';
import { InvestmentScreeningDealHistory } from 'landing-pages/investment-screening/sections/InvestmentScreeningDealHistory/InvestmentScreeningDealHistory';
import { InvestmentScreeningDesks } from 'landing-pages/investment-screening/sections/InvestmentScreeningDesks/InvestmentScreeningDesks';
import { InvestmentScreeningRegis } from 'landing-pages/investment-screening/sections/InvestmentScreeningRegis/InvestmentScreeningRegis';
import { InvestmentScreeningLedger } from 'landing-pages/investment-screening/sections/InvestmentScreeningLedger/InvestmentScreeningLedger';
import { InvestmentScreeningQuoteFaq } from 'landing-pages/investment-screening/sections/InvestmentScreeningQuoteFaq/InvestmentScreeningQuoteFaq';
import { InvestmentScreeningFinalCta } from 'landing-pages/investment-screening/sections/InvestmentScreeningFinalCta/InvestmentScreeningFinalCta';

import styles from './InvestmentScreeningPage.module.scss';

import { getDeliveryRows } from './InvestmentScreeningPage.data';

export const InvestmentScreeningPage = () => {
  const { t } = useInt();
  const { secondaryNavigation } = useContext(ContentContext);

  return (
    <div className={styles.wrapper}>
      <InvestmentScreeningHero />
      <InvestmentScreeningProblem />
      <InvestmentScreeningWorkflow />
      <InvestmentScreeningCoverage />
      <InvestmentScreeningDealHistory />
      <InvestmentScreeningDesks />
      <InvestmentScreeningRegis />
      <InvestmentScreeningLedger />
      <DeliveryTable
        title={t('Delivered the way your team works.')}
        description={t(
          'Start in the platform today, integrate when volume demands it. The underlying record never changes.',
        )}
        background="#EEF1FA"
        numbered
        rows={getDeliveryRows(t, secondaryNavigation.book_demo?.slug || 'book-a-demo')}
      />
      <InvestmentScreeningQuoteFaq />
      <InvestmentScreeningFinalCta />
    </div>
  );
};
